<template>
	<div class="labeled-info">
		<div class="label">{{label}}</div>
		<div>{{value}}</div>
	</div>
</template>

<script>
export default {
	props: ['label', 'value']
}
</script>

<style scoped lang="scss">
.labeled-info {
	font-size: 0.7em;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;


	.label {
		font-size: 0.5em;
		text-transform: uppercase;
		font-weight: bold;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/home/LabeledInfo.vue